import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState, SettingsState } from 'types/state'
import { LanguagesEnum } from 'types/index'
import { User } from 'types/user'
import { DEFAULT_LANGUAGE } from 'utils/settings'

const initialState: SettingsState = {
  numberOfQuestionsBeforeAskTicketOpen: 2,
  mode: undefined,
  token: undefined,
  areaId: undefined,
  userDetails: undefined,
  lang: LanguagesEnum.it,
  ticketReminderVisible: false,
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setTicketReminderVisible: (
      state: SettingsState,
      { payload }: PayloadAction<SettingsState['ticketReminderVisible']>,
    ) => {
      state.ticketReminderVisible = payload
    },
    setNumberOfQuestionsBeforeAskTicketOpen: (
      state: SettingsState,
      { payload }: PayloadAction<SettingsState['numberOfQuestionsBeforeAskTicketOpen']>,
    ) => {
      state.numberOfQuestionsBeforeAskTicketOpen = payload
    },
    setMode: (state: SettingsState, { payload }: PayloadAction<SettingsState['mode']>) => {
      state.mode = payload
    },
    setToken: (state: SettingsState, { payload }: PayloadAction<SettingsState['token']>) => {
      state.token = payload
    },
    setLang: (state: SettingsState, { payload }: PayloadAction<SettingsState['lang']>) => {
      state.lang = payload
    },
    setUserDetails: (state: SettingsState, { payload }: PayloadAction<SettingsState['userDetails']>) => {
      state.userDetails = payload
    },
    login: (state: SettingsState, { payload }: PayloadAction<{ token: string; user: User }>) => {
      state.token = payload.token
      state.userDetails = payload.user
    },
    logout: (state: SettingsState) => {
      state.token = undefined
      state.userDetails = undefined
    },
    setAreaId: (state: SettingsState, { payload }: PayloadAction<SettingsState['areaId']>) => {
      state.areaId = payload
    },
  },
})

export const {
  setNumberOfQuestionsBeforeAskTicketOpen,
  setMode,
  setLang,
  setToken,
  setUserDetails,
  login,
  logout,
  setTicketReminderVisible,
  setAreaId,
} = settingsSlice.actions

export const settingsActions = {
  setNumberOfQuestionsBeforeAskTicketOpen,
  setMode,
  setLang,
  setToken,
  setAreaId,
  setUserDetails,
  login,
  logout,
  setTicketReminderVisible,
}

export const settingsSelectors = {
  numberOfQuestionsBeforeAskTicketOpen: (state: RootState) => state.settingsState.numberOfQuestionsBeforeAskTicketOpen,
  userDetails: (state: RootState) => state.settingsState.userDetails,
  token: (state: RootState) => state.settingsState.token,
  lang: (state: RootState) => state.settingsState.lang || DEFAULT_LANGUAGE,
  isLogged: (state: RootState) => !!state.settingsState.token,
  userId: (state: RootState) => state.settingsState.userDetails?._id,
  userEmail: (state: RootState) => state.settingsState.userDetails?.email,
  ticketReminderVisible: (state: RootState) => state.settingsState.ticketReminderVisible,
  areaId: (state: RootState) => state.settingsState.areaId,
}
export default settingsSlice.reducer
